export const SETTING_REQUEST    = 'SETTING_REQUEST';
export const SETTING_SUCCESS    = 'SETTING_SUCCESS';
export const SETTING_FAIL       = 'SETTING_FAIL';